import React, { useState } from 'react';
import { Card, Form, Input, Button, message, Typography } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { getFirstAccessibleRoute } from '../utils/rolePermissions';

const { Title } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onLogin = async (values) => {
    setLoading(true);
    const result = await login(values.email, values.password);
    setLoading(false);

    if (result.success) {
      message.success('Login successful!');
      // Redirect user to their first accessible route
      const firstRoute = getFirstAccessibleRoute(result.user?.role);
      navigate(firstRoute);
    } else {
      message.error(result.message);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2} style={{ marginBottom: 8 }}>
            <span style={{ color: '#ff6b6b' }}>Jam</span>
            <span style={{ color: '#ffd93d', margin: '0 6px' }}>&</span>
            <span style={{ color: '#a8e6cf' }}>Sugar</span>
          </Title>
          <Typography.Text type="secondary" style={{ fontSize: '16px', fontWeight: 500 }}>
            Admin Console
          </Typography.Text>
        </div>
        <Form name="login" onFinish={onLogin} size="large">
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email!' },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Email" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Log In
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            Contact your administrator to create an account
          </Typography.Text>
        </div>
      </Card>
    </div>
  );
};

export default Login;

